import React, { PureComponent } from "react";
import { ICSSProps, ColorProps, GlobalColorPalette, CardProps, ICSS, Color, Card } from "@gago/frame";
import styled from "styled-components";
import titleLeft from "./5.svg";
import numberBg from "./bg.svg";
// tslint:disable:variable-name ter-max-len completed-docs jsx-no-multiline-js
const CropAreaCardBody = styled.div<{colorPalette: GlobalColorPalette}>`
  height: 100%;
  width: 100%;
  background-color: rgba(0, 8, 15, 0.55);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  padding: 16px;
  padding-bottom: 12px;
  .header-title{
    height: 16px;
    line-height: 1;
    color: #c2fffa;
    font-size: 16px;
    font-weight: 500;
    padding-left: 25px;
    position: relative;
    &::before{
      content: "";
      position: absolute;
      z-index: 3;
      left: 0;
      top: 2px;
      height: 12px;
      width: 17px;
      background: url("${titleLeft}") no-repeat;
      background-size: contain;
    }
  }
  .crop-area-content{
    height: calc(100% - 16px);
    width: 100%;
    padding-top: 8px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .number-item{
      height: 48px;
      width: 40px;
      font-size: 36px;
      line-height: 52px;
      text-align: center;
      font-family: BebasNeue;
      color: #c2fffa;
      background-image: url(${numberBg});
      /* background-color: rgba(0, 8, 15, 0.55); */
      background-repeat: no-repeat;
      background-size: 100% 100%;
      margin-right: 4px;
      &:last-of-type{
        margin-right: 0px;
      }
    }
    .suffix{
      font-size: 20px;
      color: #00fdff;
    }
  }
`;
type Cprops = {
  /** 标题 */
  title: string;
  /** 数量 */
  data: number;
  /** 单位 */
  suffix: string;
} & ICSSProps & ColorProps<GlobalColorPalette>;

/**
 * 作物面积类型
 * @author 马俊峰
 * @date 2020-07-24
 * @export
 * @class CropAreaCard
 * @extends {PureComponent<Cprops>}
 * @implements {ICSS}
 * @implements {Color}
 */
export class CropAreaCard extends PureComponent<Cprops> implements ICSS, Color {
  render() {
    const { colorPalette, style, className, title, data, suffix } = this.props;
    // const stringData = this.judgeDataList(data, 6);
    const stringData = String(data.toFixed(2)).split("");
    return(
      <CropAreaCardBody colorPalette={colorPalette} style={style} className={className}>
        <div className="header-title">{title}</div>
        <div className="crop-area-content">
          {stringData.map((item, num) => (
            <span className="number-item" key={`${num}data`}>{item}</span>
          ))}
          {suffix.split("").map((item, index) => (
            <span className="number-item suffix" key={`${index}suffix`}>{item}</span>
          ))}
        </div>
      </CropAreaCardBody>
    );
  }
  /** 数据格式处理 */
  judgeDataList = (data: number, digit: number) => {
    const length = String(data).length;
    const supple = digit - length;
    if (supple < 0) { console.error("传入数据大于设定位数"); return String(data).split("", digit); }
    if (supple === 0) { return String(data).split(""); }
    const datalist = String(data).split("");
    for (let index = 0; index < supple; index++) {
      datalist.unshift("0");
    }
    return datalist;
  }
}
